import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import { Grid, Hidden, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { auth, firestore, RootFirestore } from '@tabletuck/firebase-services';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { environment } from '../../../../../apps/table-tuck-web/src/environments/environment';
import {
  loggedOutSuccess,
  setCart,
  setUser,
  loggedInSuccess,
  setStores,
  UpdateScheduledTime,
  UpdateCartData,
} from '@tabletuck/redux-slices';
import { useTheme } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation } from 'react-router';
import fattyBattyLogo from '../../../../../apps/table-tuck-web/src/assets/fattyBattyLogo.png';

import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import { getFontFamily } from '../../../../../apps/table-tuck-web/src/app/Utils/fontLoader';
import { useAnonymousAuth } from 'apps/table-tuck-web/src/app/hooks/useAnonymousAuth';
import FloatingCartButton from '../../../../../apps/table-tuck-web/src/app/components/FloatingCartButton/FloatingCartButton';
/* eslint-enable @nrwl/nx/enforce-module-boundaries */
import FattyPattyMobileMenu from './FattyPattyMobileMenu';
import FattyPattyLoggedInUser from './FattyPattyLoggedInUser';
import FattyPattyAnonymousUser from './FattyPattyAnonymousUser';
import FattyPattyNoUser from './FattyPattyNoUser';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
    },
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '12px 16px',
  borderRadius: '8px',
  margin: '4px 8px',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    transform: 'translateX(4px)',
  },
}));

const StyledLogoutMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '12px 16px',
  borderRadius: '8px',
  margin: '4px 8px',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(244, 67, 54, 0.08)',
    transform: 'translateX(4px)',
  },
}));

// Export styled components for use in child components
export { StyledMenu, StyledMenuItem, StyledLogoutMenuItem };

export function Header(props) {
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const licenses = useSelector((state) => state.licenReducer.licenses);
  const cart = useSelector((state) => state.shopReducer.cart);
  const token = useSelector((state) => state.authReducer.token);
  const userData = useSelector((state) => state.authReducer.userData);
  const scheduledTime = useSelector((state) => state.shopReducer.scheduledTime);
  const [addresses] = useState([]);
  const location = useLocation();
  const [counter, setCounter] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = anchorEl;
  const stores = useSelector((state) => state.shopReducer.stores);
  const [t, i18n] = useTranslation();
  const [defaultStoreAdress, setDefaultStoreAdress] = useState('');
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [openCartDialoge, setOpenCartDialoge] = React.useState(false);
  const [anchorElProfile, setAnchorElProfile] = React.useState(null);
  const { isAnonymous, isLoggedIn } = useAnonymousAuth();

  // Define 3 clear user states for fattyPatty
  const isFattyPatty =
    props.env.restaurantId === 'fattyPattyDev' ||
    props.env.restaurantId === 'fattyPatty';

  const loggedInUser = isLoggedIn && !isAnonymous && isFattyPatty;
  const anonymousUser = isLoggedIn && isAnonymous && isFattyPatty;
  const noUser = !isLoggedIn && isFattyPatty;

  // Hide cart icon on checkout page and cart page
  const isCheckoutPage =
    location.pathname === '/confirmorder' || location.pathname === '/cart';

  const handleNavigation = (path) => {
    navigate(path);
  };
  const getStrores = async () => {
    try {
      let storeRef = firestore.collection('stores');
      storeRef = storeRef.where('is_deleted', '==', false);
      let list = [];
      const StoresList = await storeRef.get();
      for (let index = 0; index < StoresList?.docs?.length; index++) {
        let element = StoresList?.docs[index]?.data();
        element.id = StoresList?.docs[index]?.id;
        list.push(element);
      }
      dispatch(setStores(list));
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const getENV = async () => {
    // Load environment data if needed in the future
    await RootFirestore.collection('environment')
      .doc(props.env.restaurantId)
      .get();
  };

  const getCount = () => {
    let count = 0;
    for (let index = 0; index < cart?.length; index++) {
      const element = cart[index];
      count = count + element?.quantity;
    }
    setCounter(count);
  };

  const signOut = async () => {
    try {
      const savedScheduledTime = scheduledTime;
      const savedToken = token;
      dispatch(UpdateScheduledTime(null));
      dispatch(UpdateCartData({ scheduledTime: null }));
      await auth.signOut();
      dispatch(loggedOutSuccess());
      dispatch(setCart([]));
      navigate('/');
      localStorage.clear();
      if (savedToken && savedScheduledTime) {
        localStorage.setItem(
          `scheduledTime_${savedToken}`,
          JSON.stringify(savedScheduledTime)
        );
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const handleClickOpenDrawer = () => {
    // Admin drawer handler - kept for admin functionality
  };

  const handleClickOpenCartDialoge = () => {
    const isIOS =
      typeof navigator !== 'undefined' &&
      /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isIOS) {
      navigate('/cart');
      return;
    }

    setOpenCartDialoge(true);
  };
  const handleCloseCartDialoge = () => {
    setOpenCartDialoge(false);
  };

  const hoverTimerRef = useRef(null);

  const handleOpenCartDrawer = () => {
    hoverTimerRef.current = setTimeout(() => {
      setOpenCartDialoge(true);
    }, 400);
  };

  const handleLeaveCartIcon = () => {
    if (hoverTimerRef.current) {
      clearTimeout(hoverTimerRef.current);
      hoverTimerRef.current = null;
    }
  };

  const handleOpenProfileMenu = (event) => {
    setAnchorElProfile(event.currentTarget);
  };

  const handleCloseProfileMenu = () => {
    setAnchorElProfile(null);
  };

  useEffect(() => {
    stores?.filter((store) =>
      store.id === userData?.defaultStore
        ? setDefaultStoreAdress(store?.address?.displayName)
        : ''
    );
  }, [defaultStoreAdress]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const res = await firestore.collection('users').doc(user?.uid).get();
        if (res.exists) {
          const data = res.data();
          if (data?.email && data.fullName) {
            dispatch(loggedInSuccess({ token: user.uid }));
            dispatch(setUser({ user: user, userData: data }));
          }
        }
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    getCount();
  }, [cart, auth?.currentUser?.uid, token]);
  useEffect(() => {
    getENV();
    getStrores();
  }, []);
  useEffect(() => {
    setActiveLink(location.pathname);
    setAnchorEl(null);
    setAnchorElProfile(null);
    setOpenCartDialoge(false);
  }, [location.pathname]);
  return licenses ? (
    <>
      <AppBar
        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
        position="static"
        style={{
          backgroundColor: environment.mainColor,
          boxShadow: 'none',
          padding: '10px 20px',
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <div sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />

            <Typography
              onClick={() => navigate('/')}
              noWrap
              component="a"
              style={{ display: 'flex', cursor: 'pointer' }}
              variant="h6"
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 700,
                color: 'black',
              }}
            >
              {props.location === '/menu-items' ? (
                <img
                  src={fattyBattyLogo}
                  alt="fatty patty logo"
                  style={{
                    display: 'flex',
                    cursor: 'pointer',
                    width: '68px',
                  }}
                />
              ) : (
                <img
                  src={fattyBattyLogo}
                  alt="fatty patty logo"
                  style={{
                    display: 'flex',
                    cursor: 'pointer',
                    width: '68px',
                  }}
                />
              )}
            </Typography>

            {props.isAdmin ? (
              <Hidden smUp>
                <IconButton
                  styly={{
                    backgroundColor: 'white',
                    marginLeft: '10px',
                  }}
                  aria-label="open drawer"
                  edge="end"
                  onClick={handleClickOpenDrawer}
                >
                  <MenuIcon
                    style={{
                      color: 'rgb(160, 25, 19)',
                      marginLeft: '10px',
                    }}
                  />
                </IconButton>
              </Hidden>
            ) : (
              <>
                {isFattyPatty &&
                  (mdDown ? (
                    <FattyPattyMobileMenu
                      anchorEl={anchorEl}
                      openMenu={openMenu}
                      handleCloseMenu={handleCloseMenu}
                      activeLink={activeLink}
                      env={props.env}
                      restaurantId={props.env.restaurantId}
                    />
                  ) : (
                    <Grid
                      container
                      columnSpacing={{ md: 3.5, lg: 4.5, xl: 5 }}
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                      }}
                      sx={{
                        '& .MuiGrid-item': {
                          paddingLeft: {
                            md: '14px',
                            lg: '18px',
                            xl: '20px',
                          },
                        },
                      }}
                    >
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            fontWeight: activeLink === '/' ? 900 : 400,
                            textAlign: 'center',
                            color: 'white',
                            cursor: 'pointer',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() => {
                            window.location.href =
                              'https://fattypatty.zetaton.dev/';
                          }}
                          // onClick={() => navigate('/')}
                        >
                          {t('home')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            fontWeight: activeLink === '/menu' ? 900 : 400,
                            textAlign: 'center',
                            color: 'white',
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                            cursor: 'pointer',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() => handleNavigation('/menu')}
                          // onClick={() => navigate('/')}
                        >
                          {t('menuNav')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            fontWeight: activeLink === '/aboutus' ? 900 : 400,
                            textAlign: 'center',
                            color: 'white',
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                            cursor: 'pointer',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() => {
                            window.location.href =
                              'https://fattypatty.zetaton.dev/about-us';
                          }}
                        >
                          {t('about')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            fontWeight: activeLink === '/locations' ? 900 : 400,
                            textAlign: 'center',
                            color: 'white',
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                            textTransform: 'capitalize',
                            cursor: 'pointer',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() => handleNavigation('/locations')}
                        >
                          {t('locations')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            fontWeight: activeLink === '/catering' ? 900 : 400,
                            textAlign: 'center',
                            color: 'white',
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                            cursor: 'pointer',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() => handleNavigation('/catering')}
                        >
                          {t('catering')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                            fontWeight: activeLink === '/careers' ? 900 : 400,
                            textAlign: 'center',
                            textTransform: 'capitalize',
                            color: 'white',
                            cursor: 'pointer',
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() => handleNavigation('/careers')}
                        >
                          {t('join team')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                            fontWeight: activeLink === '/contactus' ? 900 : 400,
                            textAlign: 'center',
                            color: 'white',
                            cursor: 'pointer',
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() => handleNavigation('/contactus')}
                        >
                          {t('contact')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                            textTransform: 'capitalize',
                            fontWeight: activeLink === '/deals' ? 900 : 400,
                            textAlign: 'center',
                            color: 'white',
                            cursor: 'pointer',
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() => handleNavigation('/deals')}
                        >
                          {t('deals')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                            fontFamily: getFontFamily(
                              environment?.restaurantId,
                              'jost'
                            ),
                            textTransform: 'capitalize',
                            fontWeight: 400,
                            textAlign: 'center',
                            color: 'white',
                            cursor: 'pointer',
                          }}
                          sx={{
                            fontSize: {
                              md: '14px',
                              lg: '15px',
                              xl: '16px',
                            },
                          }}
                          onClick={() =>
                            window.open(
                              'https://squareup.com/gift/NBFYWH04EDE44/order',
                              '_blank'
                            )
                          }
                        >
                          Gift Card
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}

                {/* User State Components - 3 clear states for fattyPatty */}
                {!props.isAdmin && isFattyPatty && (
                  <>
                    {/* Logged In User */}
                    {loggedInUser && (
                      <FattyPattyLoggedInUser
                        counter={counter}
                        openCartDialoge={openCartDialoge}
                        onHoverCart={handleOpenCartDrawer}
                        onHoverLeaveCart={handleLeaveCartIcon}
                        handleCloseCartDialoge={handleCloseCartDialoge}
                        userData={userData}
                        anchorElProfile={anchorElProfile}
                        handleOpenProfileMenu={handleOpenProfileMenu}
                        handleCloseProfileMenu={handleCloseProfileMenu}
                        signOut={signOut}
                        navigate={navigate}
                        addresses={addresses}
                        defaultStoreAdress={defaultStoreAdress}
                        setDefaultStoreAdress={setDefaultStoreAdress}
                        mdDown={mdDown}
                        isCheckoutPage={isCheckoutPage}
                        isIOS={
                          typeof navigator !== 'undefined' &&
                          /iPad|iPhone|iPod/.test(navigator.userAgent)
                        }
                      />
                    )}

                    {/* Anonymous User */}
                    {anonymousUser && (
                      <FattyPattyAnonymousUser
                        counter={counter}
                        openCartDialoge={openCartDialoge}
                        onHoverCart={handleOpenCartDrawer}
                        onHoverLeaveCart={handleLeaveCartIcon}
                        handleCloseCartDialoge={handleCloseCartDialoge}
                        userData={userData}
                        navigate={navigate}
                        mdDown={mdDown}
                        isCheckoutPage={isCheckoutPage}
                        isIOS={
                          typeof navigator !== 'undefined' &&
                          /iPad|iPhone|iPod/.test(navigator.userAgent)
                        }
                      />
                    )}

                    {/* No User */}
                    {noUser && (
                      <FattyPattyNoUser navigate={navigate} mdDown={mdDown} />
                    )}
                  </>
                )}

                {/* Mobile menu hamburger icon for fattyPatty */}
                {isFattyPatty && mdDown && (
                  <IconButton
                    id="demo-customized-button"
                    sx={{
                      background: props.env.mainColor,
                      color: 'white',
                      marginLeft: '10px',
                      '&:hover': {
                        background: props.env.mainColor,
                      },
                    }}
                    aria-controls={
                      openMenu ? 'demo-customized-menu' : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={openMenu ? 'true' : undefined}
                    onClick={handleClick}
                  >
                    <MenuIcon />
                  </IconButton>
                )}
              </>
            )}
            {/* No User state - already handled above in the 3-state section */}
          </Toolbar>
        </Container>
      </AppBar>

      {/* Floating Cart Button - appears when navbar scrolls out of view */}
      {!isCheckoutPage && (
        <FloatingCartButton
          onOpenCart={handleOpenCartDrawer}
          isCartDrawerOpen={openCartDialoge}
        />
      )}
    </>
  ) : null;
}
export default Header;
